<div class="mobileLog">
    <div class="logTitle">
        <div class="back mr10" (click)="back()">
          <div class="backInco"></div>
        </div>
        <div>{{'log.title' | translate}}</div>
      </div>
      <div class="logNO mt40">
        <div class="logTicket">{{'log.ticket' | translate }} </div>
        <div class="ml10 logTicketNO">{{ticketNo}}</div>
      </div>
      <div class="logList">
        <ul nz-list [nzDataSource]="logListOfData" nzBordered nzSize="large" >
            <li nz-list-item *ngFor="let data of logListOfData" >
              <div class="left">
                <div>{{'log.time' | translate}}</div>
                 <div class="labelContent mb10">{{ data.createdDate | date:'dd/MM/yyyy HH:mm'}}</div>
                 <div>{{'log.action' | translate}}</div>
                 <div class="labelContent">{{ data.action }}</div>
              </div>
              <div class="right">
                <div class="content">
                  <div>{{'log.role' | translate}}</div>
                  <div class="labelContent">{{ data.userAD }}</div>
                </div>
              </div>
            </li>
          </ul>
    </div>
</div>
